export enum IFlightStatus {
	Boarding = 'Boarding',
	Canceled = 'Canceled',
	Departed = 'Departed',
	Landed = 'Landed',
	Diverted = 'Diverted',
	Scheduled = 'Scheduled',
	GateClosed = 'Gate Closed',
	InApproach = 'In Approach',
	BagClaimStarted = 'Bag Claim Started',
	FlightFinished = 'Flight Finished',
	Unknown = 'Unknown',
}
